import { mapEntityProperties } from '@/utils/mapEntityProperties'
import { BranchTagsMiniEntity } from '../../domain/entities/BranchTagsMiniEntity'
 

export class BranchTagsMiniModel extends BranchTagsMiniEntity {
  constructor(dataDto: Partial<BranchTagsMiniEntity>) {
    super()
    mapEntityProperties<BranchTagsMiniModel>(this, dataDto)
  }
} 